import { action, observable } from 'mobx'

import Ds from './ds'

class Industries {
  @observable data = []
  @observable ds = new Ds()

  @action findIndustryByName(name) {
    let id = 0;
    for(let i=0; i<this.data.length; i++) {
      if (this.data[i].name == name) {
        return this.data[i].id
      }
    }

    return id
  }

  @action loadAllIndustries() {
    this.ds.query(`{ industries(hash: "${ localStorage.getItem('userHash') }") { id name } }`,  (data) => {
      this.data = data.industries
    })
  }

  @action loadAllIndustriesWithCategories(callback) {
    this.ds.query(`{ industries(hash: "${ localStorage.getItem('userHash') }") { id name categories { id name }} }`, (data) => {
      this.data = data.industries

      if (callback) {
        callback()
      }
    })
  }

  @action newIndustry(name) {
    this.ds.query(`mutation { addIndustry(name: "${ name }", hash: "${ localStorage.getItem('userHash') }") { id } }`, (data) => {
      this.loadAllIndustries()
    })
  }

  @action updateIndustry(id, name) {
    this.ds.query(`mutation { updateIndustry(id: ${ id }, name: "${ name }", hash: "${ localStorage.getItem('userHash') }") { id } }`, (data) => {
      this.loadAllIndustries()
    })
  }

  @action deleteIndustry(id) {
    this.ds.query(`mutation { deleteIndustry(id: ${ id }, hash: "${ localStorage.getItem('userHash') }") { id } }`, (data) => {
      this.loadAllIndustries()
    })
  }
}

export default new Industries()



// WEBPACK FOOTER //
// ./src/stores/industries.js